import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AdminAuthService } from '../admin/admin-auth.service';
import { ApplicantService } from './applicant.service';
import { OpenDialog } from './dialog-for-cbs/dialog.component';
import { LaasComponent } from './laas.component';

@Injectable()
export class LaasCbsAuthGuard  {

  constructor(
    private router: Router,
    private adminAuth: AdminAuthService,
    private applicant: ApplicantService,
    public dialog: MatDialog,
    private laas: LaasComponent
  ) { }

  canActivate() {
    // if (this.adminAuth.adminLoggedIn()) {
    //   return true;
    // } else {
    //   this.router.navigate(['/login-admin']);
    // }
    // console.log('test laas authguard')

    // return true
    // return this.adminAuth.cbsStatus().pipe(map(data=>{

    // }))

    // this.applicant.getCbsStatus().subscribe(resp => {
    //   console.log(resp, "resp from laas auth guard")
    //   if (resp && resp.success) {
    //     if ((resp && resp.result && resp.result.send_to_cbs) || (resp && resp.result && resp.result.sent_to_cbs_date) || (resp && resp.result && resp.result.sent_to_cbs_id)) {


    //     } else{

    //     }
    //   }
    // })

    // if (this.adminAuth.cbsStatus()) {
    //   return true
    // } else {
    //   this.router.navigate(['/laas/applications/loan-renewal-form']);
    //   const dialogRef = this.dialog.open(OpenDialog, {
    //     width: 'auto', height: 'auto',
    //     data: { heading: "Already Sent to CBS", content: "Please check" }
    //   });

    // }

    return true
  }

}
